module.exports = __webpack_public_path__ + "img/card_v4.775d146.png";